// @ts-nocheck
require('../global.less');